<template>
  <div>
    <div class="wrapper">
      <h2 class="title">
        <em class="far fa-life-ring"></em>
      </h2>
      <h4 class="text-center">
        Want to pass on your feedback, thoughts or concerns?
      </h4>

      <div class="petition-form wwf-form light" :class="{ hide: step2 }">
        <div class="flip-wrapper" :class="{ 'formValidation-shake': isShake }">
          <div class="petition-form">
            <input
              name="emailAddress"
              type="email"
              v-model="emailAddress"
              v-validate="'required|email'"
              :class="{ 'border-red': errors.has('emailAddress') }"
              placeholder="Email Address"
            />
            <input
              name="subject"
              type="text"
              v-model="subject"
              v-validate="'required'"
              :class="{ 'border-red': errors.has('subject') }"
              placeholder="Subject"
            />
            <input
              name="phone"
              type="text"
              v-model="phone"
              min="8"
              max="12"
              v-validate="{
                required: true,
                phoneNumberIsValid: true,
              }"
              :class="{ 'border-red': errors.has('phone') }"
              placeholder="Phone"
            />
            <textarea
              name="message"
              type="text"
              v-model="message"
              v-validate="'required'"
              :class="{ 'border-red': errors.has('message') }"
              placeholder="Message"
              class
            ></textarea>

            <input type="button" v-on:click="postTicket" value="Submit" />
          </div>
        </div>
      </div>

      <div :class="{ hide: step1 || (step2 && serverErrors) }">
        <p>
          Your message has been received by our team and we will respond as soon
          as possible.
        </p>
      </div>

      <div :class="{ hide: step1 || (step2 && !serverErrors) }">
        <p>
          We are sorry, an error has occurred and your request could not be submitted. Alternatively, you can contact us by email at enquiries@wwf.org.au
        </p>
        <!-- <p class="text-center hide-for-large">
          Please tap on the orange question mark on the bottom-right of your
          screen
        </p> -->
      </div>

      <p class="text-center show-for-large">
        WWF-Australia takes all complaints and feedback seriously. For
        information about our Complaint Handling Process, please
        <a
          :href="complaintHandleUrl"
          target="_blank"
          class="document pdf"
        >
          click here
          <span class="file-info">
            &nbsp;(
            <span class="file-type">PDF</span>&nbsp;
            <span class="file-size">380.6KB</span>)
          </span> </a
        >.
      </p>
      <!-- <p class="text-center hide-for-large">
        Please tap on the orange question mark on the bottom-right of your
        screen
      </p> -->
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import gtm from '../utils/gtm';

export default {
  name: "contactUs",
  data() {
    return {
      isShake: false,
      step1: true,
      step2: false,
      serverErrors: false,
      emailAddress: "",
      subject: "",
      phone: "",
      message: "",
      isLoading: false,
    };
  },
  props:{
    // Complaint handling policy
    complaintHandleUrl: {
      type: String,
      default:"https://assets.wwf.org.au/image/upload/v1676937860/file_WWF-Au_Complaint_Handling_Policy.pdf"
    },
  },
  created() {
    // Check Phone Number
    let phoneNumberIsValid = (phoneNumber) => {
      if (phoneNumber) {
        const validationRegex = /^(\+?61|0)([0-9]{8,9})$/;
        if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
          return {
            valid: false,
            data: { message: "Invalid phone number" },
          };
        } else {
          return {
            valid: true,
          };
        }
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("phoneNumberIsValid", {
      validate: phoneNumberIsValid,
      getMessage: (field, params, data) => data.message,
    });
  },
  methods: {
    postTicket: function () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (!this.isLoading) {
            this.isLoading = true;

            // Generate a token for a special action
            await this.$store.dispatch("generateCaptchaToken", "contactUs");

            this.$http
              .post(wwfconfigs.WEB_API + "/zendesk/create", {
                emailAddress: this.emailAddress,
                subject: this.subject,
                phone: this.phone,
                message: this.message,
              })
              .then((response) => {
                this.step1 = false;
                this.step2 = true;
                this.isLoading = false;
                console.log(response);
                
                // Push form submit success event 
                gtm.formSubmitSuccessEvent('contact-us');
              })
              .catch((err) => {
                this.step1 = false;
                this.step2 = true;
                this.serverErrors = true;
                this.isLoading = false;
                console.error(err);
              });
          }
        } else {
          console.log("form invalid");
          this.isShake = true;
          setTimeout(
            function () {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
  },
};
</script>

<style scoped>
/* From elcom, integrated for Makers-tech */
a {
  color: #f37043;
}

h4 {
  font-size: 26px;
  margin: 0 0 20px;
  font-weight: 600;
}

h4, h5, h6, p, a {
  font-family: 'Lato',sans-serif;
  position: relative;
  z-index: 1;
  text-align: center;
}
/* END */

.wrapper {
  padding: 35px;
  border-radius: 5px;
  border: 1px solid var(--wwfTransparentBlack010);
  background: var(--wwfGreyF3);
}

.wrapper .title {
  margin: 0px 0px 10px;
  color: var(--wwfOrange);
  font-weight: 400;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ContactUs.vue?5072b164